var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6663 20.5H26.6663L23.333 25.5H16.6663L13.333 20.5H3.33301",
    stroke: "#181818",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08301 9.0165L3.33301 20.4998V30.4998C3.33301 31.3839 3.6842 32.2317 4.30932 32.8569C4.93444 33.482 5.78229 33.8332 6.66634 33.8332H33.333C34.2171 33.8332 35.0649 33.482 35.69 32.8569C36.3152 32.2317 36.6663 31.3839 36.6663 30.4998V20.4998L30.9163 9.0165C30.6404 8.46115 30.215 7.99379 29.6879 7.66697C29.1609 7.34015 28.5531 7.16683 27.933 7.1665H12.0663C11.4462 7.16683 10.8384 7.34015 10.3114 7.66697C9.78438 7.99379 9.35897 8.46115 9.08301 9.0165V9.0165Z",
    stroke: "#181818",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.199f99d2837fbb7462c59e4370177554.svg";
export { ForwardRef as ReactComponent };